import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const removeAccountTeamMemberSlice = getBulkActionSlice(
    'removeAccountTeamMember',
);

export const selectRemoveAccountTeamMemberUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.accountManagerUnassignResult.uuid;
export const selectRemoveAccountTeamMemberShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.accountManagerUnassignResult.shown;
export const selectRemoveAccountTeamMemberTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.accountManagerUnassignResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = removeAccountTeamMemberSlice.actions;
